<script>
import { mapState } from 'vuex';

export default {
    name: "order",
    data() {
        return {};
    },
    computed: {
        ...mapState(['shoppingData']),
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="order">
        <div class="list">
            <div class="item flex" v-for="(item, index) in shoppingData" :key="index">
                <router-link :to="item.type == 1 ? `/shop/detail?id=${item.goods_id}` : `/gallery/works/detail?id=${item.goods_id}`">
                    <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                </router-link>
                <div class="content flex flex_column justify_between">
                    <div class="info">
                        <p class="name"><router-link :to="item.type == 1 ? `/shop/detail?id=${item.goods_id}` : `/gallery/works/detail?id=${item.goods_id}`">{{ item.name }}</router-link></p>
                        <p class="price" v-if="item.price == '0.00'">免费</p>
                        <p class="price" v-else>RMB {{ item.price }}</p>
                    </div>
                    <!-- <div class="bottom flex justify_end align_center">
                        <div class="btn_del" v-if="!item.isShowDelete" @click="item.isShowDelete = true">删除</div>
                        <template v-else>
                            <div class="btn_del confirm" @click="deleteGoods(item, index)">确认删除</div>
                            <div class="btn_del" @click="item.isShowDelete = false">取消</div>
                        </template>
                        <Length v-model="item.length" min="1" @change="lengthChange($event, item, index)"/>
                        <div class="price">RMB {{ item.total_price }}</div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.order{
    padding: .8rem 0;
}
.title{
    font-size: .18rem;
    margin-bottom: .4rem;
    color: #999;
    span{
        color: var(--font_color);
    }
    @media only screen and (max-width: 750px) {
        text-align: center;
        font-size: .36rem;
    }
}
</style>